module.exports = __webpack_public_path__ + "assets/svg/UI/trash-496e90.svg";